import React from 'react'
import { Dialog, DialogContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AppointmentContent from './AppointmentContent';

const useStyles = makeStyles(() => ({
  dialog: {
    height: '90%',
    width: '100%',
  },
}));

const DialogAppointment = ({open, handleClose, appointmentId}) => {
  const classes = useStyles();

  return (
    <Dialog
      disableEscapeKeyDown
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      classes={{
        paperWidthLg: classes.dialog,
      }}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      }}
    >
      <DialogContent>
        <AppointmentContent match={{params: {id: appointmentId}}} handleCloseDialog={handleClose}/>
      </DialogContent>
    </Dialog>
  )
}

export default DialogAppointment
